
import {
    defineProps,
    computed,
    watch,
    reactive,
    toRefs,
    ref,
    onMounted,
    defineComponent,
} from 'vue'

import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { hasOwnMenu } from '@/common/functions/hasOwnMenu'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue'

interface RouteObj {
    id: string
    name: string
    route: string
    icon: string
    routes: Array<string>
    children: Array<RouteObj>
    routeName?: string
}

export default defineComponent({
    props: {
        navLinks: {
            type: Array,
            default: () => {},
        },
    },
    setup(props) {
        const { navLinks } = toRefs(props)
        const store = useStore()
        const router = useRouter()
        const route = useRoute()
        const state = reactive({
            mode: 'inline',
            theme: 'light',
            selectedKeys: ['1'],
            openKeys: ['sub1'],
        })
        const changeMode = (checked: boolean) => {
            state.mode = checked ? 'vertical' : 'inline'
        }
        const changeTheme = (checked: boolean) => {
            state.theme = checked ? 'dark' : 'light'
        }
        const toRouter = (value: RouteObj) => {
            router.push({
                name: value.routeName,
            })
            refreshBreadCrumb(value)
        }

        // 找到当前子模块的模块
        const findParentMenu = (item: RouteObj, navLinks: any) => {
            let parentMenu: any = {}
            navLinks.value.forEach((navItem: RouteObj) => {
                if (navItem && navItem.children) {
                    const isChild = navItem.children.filter(
                        (link) => link.id === item.id
                    )
                    if (isChild && isChild.length) {
                        parentMenu = navItem
                    }
                }
            })
            return parentMenu
        }
        // 更新面包屑路由
        const refreshBreadCrumb = (item: RouteObj) => {
            // 当前路由
            const breadCrumbList: any = [item.name]
            // 如果点击的是父功能模块
            if (item.children && item.children.length) {
                breadCrumbList.push(item.children[0].name)
            } else {
                // 如果点击的是子功能模块
                const navItem: any = findParentMenu(item, navLinks)
                if (navItem && navItem.name) {
                    breadCrumbList.unshift(navItem.name)
                }
            }
            store.commit('setRouterPaths', breadCrumbList)
        }

        const collapsed = ref<boolean>(false)
        const toggleCollapsed = () => {
            collapsed.value = !collapsed.value
        }
        return {
            store,
            router,
            route,
            state,
            changeMode,
            changeTheme,
            toRouter,
            findParentMenu,
            refreshBreadCrumb,
            collapsed,
            toggleCollapsed,
            hasOwnMenu,
        }
    },
})
